import {animate, AnimationTriggerMetadata, style, transition, trigger} from '@angular/animations';

export const slideCollapseAnimation: AnimationTriggerMetadata = trigger('slideCollapse', [
  transition(':enter', [
    style({ height: 0, opacity: 0, marginTop: 0, marginBottom: 0, overflow: 'hidden' }),
    animate('250ms ease-in-out', style({ height: '*', opacity: 1 }))
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate('250ms ease-in-out', style({ height: 0, opacity: 0 }))
  ])
]);
